import { Link } from "react-router-dom";
import { AiOutlinePlus } from "react-icons/ai";
import { RiQuestionMark } from "react-icons/ri";
import "../assets/css/main.css";
import "../assets/css/student.css";

interface addUserCard {
  title: any;
  content: string;
  link?: string;
  hiddenQ?: boolean;
}

export const AddUserCard = ({ title, content, link, hiddenQ }: addUserCard) => {
  return (
    <Link
      to={`${link}`}
      className="group block w-full sm:w-[420px] mr-4 mb-4 bg-white border border-slate-100 rounded-2xl p-7 shadow-md hover:shadow-xl hover:border-slate-200 transform hover:-translate-y-1 transition-all duration-300 text-left"
    >
      <div className="flex items-center justify-between gap-6 w-full min-h-[100px]">
        {/* Left Side: Expanded Content Typography Matrix */}
        <div className="flex-1 min-w-0 space-y-2">
          <h2 className="text-[18px] font-extrabold text-slate-800 tracking-tight capitalize group-hover:text-[#0096D1] transition-colors duration-300">
            {title}
          </h2>
          <p className="text-xs font-semibold text-slate-400 leading-relaxed max-w-[260px]">
            {content}
          </p>
        </div>

        {/* Right Side: High-Impact Hero Action Badge */}
        <div className="flex-shrink-0">
          {hiddenQ ? (
            <div className="h-14 w-14 rounded-2xl bg-slate-50 border border-slate-100 flex items-center justify-center text-slate-400 shadow-inner group-hover:bg-[#0096D1]/10 group-hover:text-[#0096D1] group-hover:border-transparent transform group-hover:rotate-12 transition-all duration-300">
              <RiQuestionMark className="text-2xl" />
            </div>
          ) : (
            <div className="h-14 w-14 rounded-2xl bg-[#0096D1]/10 text-[#0096D1] shadow-sm group-hover:bg-[#0096D1] group-hover:text-white flex items-center justify-center transform group-hover:scale-110 group-hover:rotate-90 transition-all duration-300">
              <AiOutlinePlus className="text-2xl" />
            </div>
          )}
        </div>
      </div>
    </Link>
  );
};
